export enum MaritalStatus {
  Single = 'single',
  Married = 'married',
  Divorced = 'divorced',
  Widowed = 'widowed',
  RegisteredCivilPartnership = 'registered_civil_partnership',
  Cohabitation = 'cohabitation',
}
